import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, InputAdornment, TextField, Alert } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import "./login.css";

import loginBg from "../../../assets/login-bg.jpg";

import { postApiCall } from "../../utils/Apicalls";

const LoginScreen = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] =
    React.useState(false);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("userDetails");
    if (userId) {
      navigate("/admin-home");
    }
  }, [navigate]);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const onSubmit = async () => {
    setError("");
    setLoading(true);
    try {
      const result = await postApiCall(`badminton-app/auth/login`, {
        email: userName,
        password: password,
      });
      if (result?.status && result?.result && result?.token) {
        localStorage.setItem("userDetails", JSON.stringify(result.result));
        localStorage.setItem("token", result.token);
        navigate("/admin-home");
      } else {
        setError(result?.error || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{
        backgroundImage: `url(${loginBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="card shadow-lg p-4"
        style={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "rgba(255,255,255,0.9)",
        }}
      >
        <div className="text-center mb-4">
          <h2 className="fw-bold text-dark">Welcome Back 👋</h2>
          <p className="text-muted">
            Login to your{" "}
            <span
              className="text-primary fw-semibold cursor-pointer"
              onClick={() => navigate("/")}
            >
              Nishjesh Sports AI
            </span>{" "}
            account
          </p>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          {error && !loading && (
            <div className="login-error-alert">
              <Alert severity="error">{error}</Alert>
            </div>
          )}
          {/* Email */}
          <div className="mb-3 mt-3">
            <label htmlFor="email" className="form-label fw-semibold">
              Email address
            </label>
            <TextField
              id="email-input"
              label=""
              variant="outlined"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Enter your email"
              fullWidth
              type="email"
              required
            />
          </div>

          {/* Password */}
          <div className="mb-3">
            <label htmlFor="password" className="form-label fw-semibold">
              Password
            </label>
            <TextField
              id="password-input"
              label=""
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              fullWidth
              type={showPassword ? "text" : "password"}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleTogglePassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          {/* Remember + Forgot Password */}
          {/* <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="rememberMe"
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember me
              </label>
            </div>
            <a href="#" className="text-decoration-none text-primary">
              Forgot password?
            </a>
          </div> */}

          {/* Sign In Button */}
          <button type="submit" className="btn btn-primary w-100 fw-semibold">
            Sign In
          </button>
        </form>

        {/* Divider */}
        {/* <div className="text-center my-3 position-relative">
          <hr />
          <span
            className="position-absolute top-50 start-50 translate-middle bg-white px-2 text-muted small"
            style={{ marginTop: "-1px" }}
          >
            or
          </span>
        </div> */}

        {/* Social Buttons */}
        {/* <div className="d-grid gap-2">
          <button className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2">
            <img
              src="https://www.svgrepo.com/show/355037/google.svg"
              alt="Google"
              width={20}
              height={20}
            />
            Continue with Google
          </button>
          <button className="btn btn-outline-primary d-flex align-items-center justify-content-center gap-2">
            <img
              src="https://www.svgrepo.com/show/452196/facebook-1.svg"
              alt="Facebook"
              width={20}
              height={20}
            />
            Continue with Facebook
          </button>
        </div> */}

        {/* Signup */}
        {/* <p className="text-center text-muted mt-4 mb-0">
          Don’t have an account?{" "}
          <a href="#" className="fw-semibold text-primary text-decoration-none">
            Sign up
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default LoginScreen;
